// 引入路由变化监听器
window.popStateResgister = {}
function actionListener (target, event, callback) {
  if (target.addEventListener) {
    target.addEventListener(event, callback, false)
  } else {
    target.attachEvent(event, callback)
  }
}

actionListener(window, 'popstate', function (event) {
  if (event.state && window.popStateResgister[event.state.type]) {
    window.popStateResgister[event.state.type].callback &&
    window.popStateResgister[event.state.type].callback(event.state.args)
  }
})
